import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Tracks page views into MongoDB on every route change.
 * Skips repeated views for the same path within 1 second (back/forward).
 */
export default function PageTracker() {
  const loc = useLocation();
  const lastTracked = useRef({ path: "", ts: 0 });

  useEffect(() => {
    const now = Date.now();
    if (lastTracked.current.path === loc.pathname && now - lastTracked.current.ts < 1000) {
      return;
    }
    lastTracked.current = { path: loc.pathname, ts: now };

    // Optional: pass episode_id if URL contains /episodes/:id pattern in future
    api.post("/track", { path: loc.pathname }).catch(() => {});
  }, [loc.pathname]);

  return null;
}
